(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dc-gauge"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.dc-gauge').forEach(function (el) {
      if (el.dataset.dcRendered === '1') return;
      const pct = parseFloat(el.dataset.pct) || 0;
      const r = 46;
      const c = 2 * Math.PI * r;
      const fill = (pct / 100) * c;
      const gap = c - fill;
      const endAngle = (-Math.PI / 2) + ((pct / 100) * Math.PI * 2);
      const capOuterR = 46.7;
      const capInnerR = 37;
      const capEndX1 = 50 + (capOuterR * Math.cos(endAngle));
      const capEndY1 = 50 + (capOuterR * Math.sin(endAngle));
      const capEndX2 = 50 + (capInnerR * Math.cos(endAngle));
      const capEndY2 = 50 + (capInnerR * Math.sin(endAngle));
      const label = el.dataset.label || '';
      el.innerHTML =
        '<svg viewBox="0 0 100 100" aria-hidden="true">' +
          '<g transform="rotate(-90 50 50)">' +
            '<circle class="dc-gauge__track" cx="50" cy="50" r="50"></circle>' +
            '<circle class="dc-gauge__arc" cx="50" cy="50" r="' + r + '" stroke-dasharray="' + fill.toFixed(2) + ' ' + gap.toFixed(2) + '" stroke-dashoffset="0"></circle>' +
          '</g>' +
          '<line class="dc-gauge__cap" x1="50" y1="3.3" x2="50" y2="13"></line>' +
          '<line class="dc-gauge__cap" x1="' + capEndX1.toFixed(2) + '" y1="' + capEndY1.toFixed(2) + '" x2="' + capEndX2.toFixed(2) + '" y2="' + capEndY2.toFixed(2) + '"></line>' +
        '</svg>' +
        '<div class="dc-gauge__inner">' +
          '<div class="dc-gauge__pct">' + pct + '%</div>' +
          '<div class="dc-gauge__label"></div>' +
        '</div>';
      el.querySelector('.dc-gauge__label').textContent = label;
      el.dataset.dcRendered = '1';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
